<template>
  <button type="button" :class="[
    'product-spec-value',
    displayType === 'image' ? 'is-image' : '',
    isChecked ? 'is-active' : '',
    isDisabled ? 'is-disabled' : '',
    isTaken ? 'is-taken' : '',
  ]" @click="handleColorClick()" @mouseenter="handleMouseEnter" v-if="displayType === 'image'">
    <i class="spec-icon" :style="{ background: color.background }">
      <img src="//img66.anypromo.com/WebSite2016/ImageResource/color_close.png" class="close" /></i>
    <div class="dis-mask"></div>
    <i class="icon-out-of-stock" v-show="color.outOfStock">&nbsp;</i>
  </button>
  <button type="button" :class="[
    'btn-select',
    isChecked ? 'is-active' : '',
    isDisabled ? 'is-disabled' : '',
    isTaken ? 'is-taken' : '',
  ]" @click="handleColorClick()" v-else-if="displayType === 'button'">
    {{ color.text }}
  </button>
  <div v-else :class="[
    'btn-select',
    isChecked ? 'is-active' : '',
    isDisabled ? 'is-disabled' : '',
    isTaken ? 'is-taken' : '',
  ]" @click="handleColorClick()">
    <span>{{ color.text }}</span>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from 'vue'
import { type DisplayType, type ProductSpecItem } from '../../types'

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<ProductSpecItem>,
      default: {} as unknown
    },
    color: {
      type: Object as PropType<ProductSpecItem>,
      default: {} as unknown
    },
    selected: {
      type: Boolean,
      default: false
    },
    displayType: {
      type: String as PropType<DisplayType>,
      default: 'image'
    },
    groupIndex: {
      type: Number,
      default: 0
    }
  },
  emits: {
    hover: (groupIndex: number, val: ProductSpecItem, el: HTMLElement) => true,
    click: (val: ProductSpecItem) => true
  },
  setup (props, { emit }) {
    const isDisabled = computed(() => !props.color.enabled)
    const isChecked = computed(() => props.selected)
    const isTaken = computed(() => props.color.selected)

    const handleMouseEnter = (evt: MouseEvent) => {
      const target = evt.target! as HTMLElement
      emit('hover', props.groupIndex, props.color, target)
    }

    const handleColorClick = () => {
      if (props.color.selected) return
      emit('click', props.color)
    }
    return {
      isDisabled,
      isChecked,
      isTaken,
      handleMouseEnter,
      handleColorClick
    }
  }
})
</script>

<style lang="less">
.product-spec-value {
  margin: 5px 0;
  display: inline-block;
  border: 1px #ccc solid;
  padding: 5px 10px;
  margin-right: 10px;
  font-size: 13px;
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
  outline: 0 none !important;

  .dis-mask {
    display: none;
  }

  &:hover {
    background: #ededed;
  }

  &.is-active {
    border-color: red;
    border-width: 2px;
    padding: 1px;

    &:hover {
      img {
        display: block;
        position: absolute;
        top: 5px;
        left: 7px;
      }
    }
  }

  &.is-image {
    height: 30px;
    width: 30px;
    padding: 2px;
    margin-right: 4px;
    border: 1px solid #bbb;
    background: #fff;
    box-sizing: content-box;
    position: relative;

    .spec-icon {
      width: 30px;
      height: 30px;
      display: block;
      margin: 0 auto;
      cursor: pointer;
      position: relative;
      background-position: 100% 100%;
      background-size: contain;
      background-repeat: no-repeat;

      img {
        display: none;
      }
    }

    .dis-mask {
      display: none;
      z-index: 1;
      position: absolute;
      background-color: #f5f5f5;
      top: -1px;
      left: -1px;
      width: 36px;
      height: 36px;
      opacity: 0.8;
    }

    &.is-active {
      border-color: red;
      border-width: 2px;
      padding: 1px;

      &:hover {
        .spec-icon {
          img {
            display: block;
          }
        }
      }
    }

    &.is-disabled {

      // &::after {
      //   content: "";
      //   display: block;
      //   z-index: 1;
      //   position: absolute;
      //   background-color: #f5f5f5;
      //   top: -1px;
      //   left: -1px;
      //   width: 36px;
      //   height: 36px;
      //   opacity: 0.8;
      // }
      .dis-mask {
        display: block;
      }
    }

    &.is-taken {
      border: 1px dashed #bbb;

      &::focus {
        box-sizing: none;
      }

      &:hover {
        img {
          display: none;
        }
      }

      .dis-mask {
        display: block;

        &::after {
          content: "";
          width: 20px;
          height: 20px;
          position: absolute;
          top: 8px;
          left: 8px;
          z-index: 3000;
          background-image: url(https://img66.anypromo.com/frontimg/2019/Icon/select4.svg);
        }
      }
    }
  }

  &.is-image.is-one {}

  &--button {
    margin: 5px 0;
    display: inline-block;
    border: 1px #ccc solid;
    padding: 5px 10px;
    margin-right: 10px;
    font-size: 13px;
    background: #fff;
    border-radius: 3px;
    cursor: pointer;
    outline: 0 none !important;

    &.active {
      border: 1px #eda88e solid;
      background-color: #fff3ea;
      color: #4e4e4e;
    }

    &.is-disabled {}

    &.is-taken {
      border: 1px dashed #bbb;

      &::focus {
        box-sizing: none;
      }
    }
  }
}

.icon-out-of-stock {
  width: 10px;
  height: 10px;
  background: url(https://img66.anypromo.com/frontimg/2020/icon/ico-warning.svg) no-repeat 0 0;
  position: absolute;
  top: -3px;
  right: 0;
  z-index: 999;
}
</style>
